import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import PhotoSizeSelectSmallIcon from "@mui/icons-material/PhotoSizeSelectSmall";
import { makeStyles } from "@mui/styles";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import { useTranslation } from "react-i18next";
import { useNavigate,useLocation } from "react-router-dom";
import { Modal, Typography, Box } from "@mui/material";
import AlertDialog from "../components/AlertDialog";
import Tooltip from "@mui/material/Tooltip";
import LocalTaxiOutlinedIcon from "@mui/icons-material/LocalTaxiOutlined";
import { carTypeColumns, optionsRequired } from "common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import BlankTable from '../components/Table/BlankTable';
import localization from '../components/Table/Localization';
import { getLangKey } from "common/src/other/getLangKey";
import { formatMoney } from "common/src/other/currencyFormat";
import { C2_FONT } from "../components/conecta2ModalStyles";
import CarTypeImageModal from "../components/CarTypeImageModal";
import {
  C2,
  c2TableTheme,
  c2TableOptions,
  c2TableStyle,
  c2Toolbar,
  c2Localization,
  C2TableCard,
  C2AddButton,
  C2EmptyState,
  C2DocsChip,
} from "../components/Table/C2UserTable";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarTypes() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { editCarType, convertLanguage } = api;
  const [data, setData] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const [modalType, setModalType] = useState();
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  const auth = useSelector((state) => state.auth);

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  const onClick = (rowData) => {
    setImageData(rowData.image);
    setProfileModal(true);
    setUserData(rowData);
  };

  const columns = carTypeColumns(t, isRTL, onClick, (rowData, checked) => {
    if (settings.AllowCriticalEditsAdmin) {
      const updated = { ...rowData, visibleInApp: checked };
      delete updated.tableData;
      dispatch(editCarType(updated, "Update"));
    }
  }).map((col) => {
    if (col.field === "name") {
      return {
        ...col,
        render: (rowData) =>
          rowData.name ? (
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: "0.9rem", color: C2.sidebar }}>
              {t(getLangKey(rowData.name))}
            </Typography>
          ) : null,
      };
    }
    if (col.field === "image") {
      return {
        ...col,
        render: (rowData) =>
          rowData.image ? (
            <Tooltip title={t("upload_car_image")}>
              <Box
                component="button"
                type="button"
                onClick={() => onClick(rowData)}
                sx={{
                  width: 72,
                  height: 48,
                  mx: "auto",
                  p: 0.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "12px",
                  border: `1px solid ${C2.border}`,
                  backgroundColor: C2.lavender,
                  cursor: "pointer",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    borderColor: C2.violet,
                    boxShadow: "0 4px 12px rgba(100,17,237,0.18)",
                  },
                }}
              >
                <img alt="CarImage" src={rowData.image} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
              </Box>
            </Tooltip>
          ) : null,
      };
    }
    if (col.field === "fleet_admin_fee") {
      return {
        ...col,
        render: (rowData) =>
          rowData.fleet_admin_fee != null && rowData.fleet_admin_fee !== ""
            ? `${rowData.fleet_admin_fee} %`
            : "—",
      };
    }
    if (col.field === "convenience_fees") {
      return {
        ...col,
        render: (rowData) => {
          const v = rowData.convenience_fees;
          if (v == null || v === "") return "—";
          return rowData.convenience_fee_type === "percentage"
            ? `${v} %`
            : formatMoney(v, settings || { country: "Colombia", code: "COP" });
        },
      };
    }
    return col;
  });
  const subcolumns = [
    {
      title: t("description"),
      field: "description",
      render: (rowData) => <span>{t(getLangKey(rowData.description))}</span>,
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

  const subcolumns2 = [
    {
      title: t("minsDelayed"),
      field: "minsDelayed",
      render: (rowData) => <span>{rowData.minsDelayed}</span>,
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (cartypes.cars) {
      setData(cartypes.cars);
    } else {
      setData([]);
    }
  }, [cartypes.cars]);

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if(settings.AllowCriticalEditsAdmin){
    if (selectedImage) {
      const finalData = { ...userData, image: selectedImage };
      delete finalData.tableData;
      dispatch(editCarType(finalData, "UpdateImage"));
      setProfileModal(false);
      setSelectedImage(null);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  }else{
    setCommonAlert({ open: true, msg: t('demo_mode') })
  }
  };

  const [selectedRow, setSelectedRow] = useState(null);

  const tableComponents = c2Toolbar(
    <C2AddButton
      label="Agregar tipo de vehículo"
      onClick={() => navigate("/cartypes/editcartype",{state:{pageNo:currentPage}})}
    />
  );
  const tableLocalization = c2Localization(
    localization(t),
    <C2EmptyState
      icon={LocalTaxiOutlinedIcon}
      message="Aún no hay tipos de vehículo. Crea el primero (Taxi, C2, Moto, C2 Mujer…) para que los usuarios puedan pedir su viaje."
    />
  );

  return cartypes.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
    <ThemeProvider theme={c2TableTheme}>
      <C2TableCard>
      {data?.length >0 ?
      <MaterialTable
        title={t("car_type_title")}
        columns={columns}
        onChangePage={(page)=>HandalePageChange(page)}
        style={c2TableStyle(isRTL)}
        data={data}
        components={tableComponents}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          ...c2TableOptions(selectedRow),
          initialPage:state?.pageNo,
          exportButton: true,
        }}
        localization={tableLocalization}
        editable={{
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(editCarType(oldData, "Delete"));
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
        actions={[
          (rowData) =>
            optionsRequired
              ? {
                  icon: () => <C2DocsChip icon={PhotoSizeSelectSmallIcon} label={t("parcel_types")} />,
                  tooltip: t("parcel_types"),
                  onClick: (event, rowData) => {
                    setModalType("parcelTypes");
                    setRowIndex(rowData.tableData.id);
                    setOpen(true);
                  },
                }
              : null,
          (rowData) =>
            optionsRequired
              ? {
                  icon: () => <C2DocsChip icon={FitnessCenterIcon} label={t("options")} />,
                  tooltip: t("options"),
                  onClick: (event, rowData) => {
                    setModalType("options");
                    setRowIndex(rowData.tableData.id);
                    setOpen(true);
                  },
                }
              : null,
          (rowData) => ({
            icon: () => <C2DocsChip icon={CancelScheduleSendIcon} label={t("cancelSlab")} />,
            tooltip: t("cancelSlab"),
            onClick: (event, rowData) => {
              setModalType("cancelSlab");
              setRowIndex(rowData.tableData.id);
              setOpen(true);
            },
          }),
          {
            icon: "edit",
            tooltip: t("edit"),
            onClick: (event, rowData) => {
              navigate(`/cartypes/editcartype/${rowData.id}`,{state:{pageNo:currentPage}});
            },
          },
        ]}
      />
      : <BlankTable title={t('car_type_title')} 
      actions={[]}
      components={tableComponents}
      style={c2TableStyle(isRTL)}
      columns={columns}  data={[]} localization={tableLocalization} options={c2TableOptions(null)}/>}
      </C2TableCard>
    </ThemeProvider> 
      <CarTypeImageModal
        open={profileModal}
        onClose={handleProfileModal}
        onSave={handleSetProfileModal}
        container={() => rootRef.current}
        isRTL={isRTL}
        title={t("upload_car_image")}
        carTypeName={userData?.name ? t(getLangKey(userData.name)) : ""}
        currentImage={imageData || null}
        selectedImage={selectedImage}
        onSelectImage={setSelectedImage}
      />
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        onClose={handleClose}
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Box sx={{
          width: 700,
          maxWidth: '92vw',
          maxHeight: '90vh',
          overflowY: 'auto',
          p: { xs: 1.5, sm: 2.5 },
          borderRadius: '16px',
          border: `1px solid ${C2.border}`,
          boxShadow: '0 16px 40px rgba(26,15,59,0.18)',
          backgroundColor: C2.white,
          direction: isRTL === "rtl" ? "rtl" : "ltr",
        }}>
        <ThemeProvider theme={c2TableTheme}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 0.5, mb: 0.5 }}>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `linear-gradient(135deg, ${C2.violet}, ${C2.bright})`,
              boxShadow: '0 6px 14px rgba(100,17,237,0.28)',
              flexShrink: 0,
            }}>
              {modalType === "options" ? (
                <FitnessCenterIcon sx={{ color: C2.white, fontSize: 22 }} />
              ) : modalType === "cancelSlab" ? (
                <CancelScheduleSendIcon sx={{ color: C2.white, fontSize: 22 }} />
              ) : (
                <PhotoSizeSelectSmallIcon sx={{ color: C2.white, fontSize: 22 }} />
              )}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontFamily: C2_FONT, fontWeight: 800, fontSize: '1.05rem', color: C2.sidebar, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                {modalType === "options"
                  ? t("options")
                  : modalType === "cancelSlab"
                  ? t("cancelSlab")
                  : t("parcel_types")}
              </Typography>
              {data[rowIndex]?.name ? (
                <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.85rem', color: C2.muted }}>
                  {t(getLangKey(data[rowIndex].name))}
                </Typography>
              ) : null}
            </Box>
          </Box>
          <MaterialTable
            title=""
            columns={modalType === "cancelSlab" ? subcolumns2 : subcolumns}
            data={
              data[rowIndex] && data[rowIndex][modalType]
                ? data[rowIndex][modalType]
                : []
            }
            style={c2TableStyle(isRTL)}
            localization={localization(t)}
            options={{
              exportButton: true,
              actionsColumnIndex: -1,
              showTitle: false,
              searchFieldAlignment: "right",
              headerStyle: c2TableOptions(null).headerStyle,
              cellStyle: c2TableOptions(null).cellStyle,
              searchFieldStyle: c2TableOptions(null).searchFieldStyle,
            }}
            editable={{
              onRowAdd: (newData) =>
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve) => {
                      setTimeout(async() => {
                        resolve();
                        let tblData = data;
                        if (!tblData[rowIndex][modalType]) {
                          tblData[rowIndex][modalType] = [];
                        }
                        tblData[rowIndex][modalType].push(newData);
                        if(newData.description && (modalType !== "cancelSlab")){
                          await convertLanguage(newData.description, auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null);
                        }
                        dispatch(editCarType(tblData[rowIndex]), "Update");
                      }, 600);
                    })
                  : new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        alert(t("demo_mode"));
                      }, 600);
                    }),
              onRowUpdate: (newData, oldData) =>
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve) => {
                      setTimeout(async () => {
                        resolve();
                        if (newData !== oldData) {
                          let tblData = data;
                          tblData[rowIndex][modalType][oldData.tableData.id] =
                            newData;
                            if(oldData.description !== newData.description && (modalType !== "cancelSlab")){
                              await convertLanguage(newData.description, auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null);
                            }
                          dispatch(editCarType(tblData[rowIndex]), "Update");
                        }
                      }, 600);
                    })
                  : new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        alert(t("demo_mode"));
                      }, 600);
                    }),
              onRowDelete: (oldData) =>
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        let tblData = data;
                        const index = tblData[rowIndex][modalType];
                        const neTtblData = index.filter(
                          (item) =>
                            item.amount !== oldData.amount &&
                            (modalType === "cancelSlab"
                              ? item.minsDelayed !== oldData.minsDelayed
                              : item.description !== oldData.description)
                        );
                        tblData[rowIndex][modalType] = neTtblData;
                        dispatch(editCarType(tblData[rowIndex]), "Update");
                      }, 600);
                    })
                  : new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        alert(t("demo_mode"));
                      }, 600);
                    }),
            }}
          />
        </ThemeProvider>
        </Box>
      </Modal>
    </div>
  );
}
